import React, { useRef } from 'react';
import ct from 'countries-and-timezones';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import { Button, Modal, Form, Input, Select, Alert } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const { Option } = Select;

const timezones = ct.getAllTimezones();

function AddDeviceModal({
  t,
  pin,
  setPin,
  loading,
  showForm,
  toggle,
  calendars,
  onFinish,
}) {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const onSubmit = () => {
    formRef.current.submit();
  };
  const onCancel = () => {
    setPin(null);
    toggle();
  };

  const sortedTimezones = reverse(sortBy(timezones, 'utcOffset'));

  return (
    <div className="add-device-modal">
      <Button icon={<PlusOutlined />} type="primary" onClick={toggle}>
        {t('add-device')}
      </Button>
      <Modal
        title={t('add-device')}
        visible={showForm}
        onCancel={onCancel}
        footer={
          <Button loading={loading} onClick={onSubmit} type="primary">
            {t('add')}
          </Button>
        }
      >
        <Form
          ref={formRef}
          form={form}
          name="add-device"
          layout="vertical"
          onFinish={(values) => {
            onFinish(values, () => {
              form.resetFields();
              toggle();
            });
          }}
        >
          <Form.Item
            name="name"
            label={t('device-name')}
            rules={[{ required: true, message: t('enter-device-name') }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="calendarId" label={t('calendar-related')}>
            <Select placeholder={t('select')}>
              {map(calendars, ({ id, name }) => (
                <Option value={id} label={name}>
                  {name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="timezone" label={t('timezone-label')}>
            <Select placeholder={t('select')} showSearch>
              {map(sortedTimezones, ({ name, utcOffsetStr }) => (
                <Option value={name}>{`${utcOffsetStr} ${name}`}</Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
        {/*{pin && (*/}
        {/*  <Alert*/}
        {/*    className="add-device-modal__alert"*/}
        {/*    message={`${t('active-device')} ${pin}`}*/}
        {/*    type="warning"*/}
        {/*  />*/}
        {/*)}*/}
      </Modal>
    </div>
  );
}

export default AddDeviceModal;
